/* eslint-disable no-unused-vars */
export default function clearAction(state, payload) {
  return { event: {} };
}
